import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { Title } from '@angular/platform-browser';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { GeoService } from 'src/app/services/geo.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListStatesComponent implements OnInit {
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: false
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight',
    rowSelection: 'multiple'
  };

  columnDefs = [
    { headerName: 'Code', field: 'code', filter: true },
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'GST Alise', field: 'gstalise', filter: true },
    { headerName: 'Country', field: 'countryname', filter: true },
    {
      headerName: 'Status',
      field: 'isactive',
      cellRenderer: (params: { value: boolean; }) => {
        // console.log(params);
        let statusHtml = '<span class="badge bg-dark">Not Active</span>';
        if (params.value) {
          statusHtml = '<span class="badge badge-pill bg-success">Active</span>';
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];

  rowData = [];
  selectedSCId: number;

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private geoService: GeoService,
    private titleService: Title
  ) {
    titleService.setTitle('States');
    this.context = { componentParent: this }
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
      });
      this.bindStateList();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'States');
    // console.log("permission", permission)
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindStateList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.geoService.getAllStatesList({ refresh: refresh }).subscribe((res: any) => {
        // console.log(res);
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    // console.log("editaction", cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        // console.log("editaction-allowed");
        this.router.navigate(['/setup/geo/states/edit', cell.id]);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async deleteAction(cell: any) {
    // console.log("Deleteaction", cell);
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      // console.log("Deleteaction-allowed");
      const result = await this.openConfirmationDialog('Are you sure ?', 'You want to delete.', cell.id);
      result ? this.deleteRecord(cell.id) : null;
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.geoService.deleteState(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindStateList(true);
            this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  async openConfirmationDialog(msg1: any, msg2?: any, id?: number): Promise<boolean> {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      html: msg2 ? `<span>${msg1}</span><br><span>${msg2}</span>` : `<span>${msg1}</span>`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false,
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  errAlert(msg: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
    });
  }

  formateDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (e) {
      console.error('Error occurred during date parsing:', e);
      return '';
    }
  }





}
